import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/inkind";

export const Route = createFileRoute("/admin/_donation-setup/inkind")({
  component: Page,
});
